'use client';

import { Star } from '@icons';
import './_review-block.scss';
import useDictionary from '@modules/Dictionary/useDictionary';

export default function ReviewBlock({ score, maxScore = 5, ratingCount, link = null }) {
  const { dictionary } = useDictionary();

  if (!score) return null;

  const stars = [];
  for (let i = 0; i < maxScore; i++) {
    stars.push(<Star key={i} />);
  }

  let verdictKey = 'terrible';
  const numScore = parseFloat(score);
  if (numScore > 4.4) verdictKey = 'excellent';
  else if (numScore >= 3.5) verdictKey = 'veryGood';
  else if (numScore >= 2.5) verdictKey = 'average';
  else if (numScore >= 1.5) verdictKey = 'poor';

  return numScore > 0.0 ? (
    <div className="ReviewBlock">
      <div>
        <p className="ReviewBlock__score-label">{numScore.toFixed(1)}</p>
        <p className="ReviewBlock__score-value">{stars}</p>
      </div>
      <div className="ReviewBlock__verdict">{dictionary?.review?.[verdictKey] || verdictKey}</div>
      {!!ratingCount && (
        <div>
          <p className="ReviewBlock__score-label">{ratingCount}</p>
          {link ? (
            <a href={link} target="_blank" rel="noopener noreferrer" className="ReviewBlock__score-value">
              {dictionary?.review?.reviews || 'reviews'}
            </a>
          ) : (
            <span className="ReviewBlock__score-value">{dictionary?.review?.reviews || 'reviews'}</span>
          )}
        </div>
      )}
    </div>
  ) : null;
}
